<script>
import { Icon } from 'ant-design-vue'
import STable from '@/components/Table/'
import { changeUserMembership, deleteSharePermission, loadPermissionList, switchEmailAlertEnable } from '@/api/data'
import QrBind from '@/views/data/modal/QrBind.vue'
import EmailBind from '@/views/data/modal/EmailBind.vue'
import UserProfile from '@/views/data/modal/UserProfile.vue'
import MembershipUpgrade from '@/views/data/modal/MembershipUpgrade.vue'
import CreateAccount from '@/views/data/modal/CreateAccount.vue'
import ResetPassword from '@/views/data/modal/ResetPassword.vue'
import moment from 'moment'
import MembershipUpgradeBatch from '@/views/data/modal/MembershipUpgradeBatch.vue'
import { getI18nLanguage } from '@/locales'

const IconFont = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_4667817_6r4uyhchvik.js'
})
export default {
  name: 'DriverList',
  components: {
    STable,
    IconFont
  },
  data () {
    return {
      expireNum: 0,
      col: {
        lg: 8,
        xl: 6
      },
      locale: {
        emptyText: this.$t('table.emptyText')
      },
      columns: [{
        title: this.$t('user.name'),
        dataIndex: 'name',
        align: 'center',
        key: 'name'
      }, {
        title: this.$t('user.org.name'),
        dataIndex: 'org_name',
        align: 'center',
        key: 'org_name'
      }, {
        title: this.$t('user.account'),
        dataIndex: 'account',
        align: 'center',
        key: 'account'
      }, {
        title: this.$t('user.email.alert'),
        dataIndex: 'email_alert',
        align: 'center',
        key: 'email_alert',
        scopedSlots: { customRender: 'email_alert' },
        width: 120
      }, {
        title: this.$t('user.membership.level'),
        dataIndex: 'level',
        align: 'center',
        width: 180,
        scopedSlots: { customRender: 'level' },
        key: 'level'
      }, {
        title: this.$t('user.membership.expire.time'),
        dataIndex: 'level_expire',
        align: 'center',
        width: 160,
        scopedSlots: { customRender: 'expire' },
        key: 'level'
      }, {
        title: this.$t('user.share.status'),
        dataIndex: 'status',
        align: 'center',
        width: 100,
        scopedSlots: { customRender: 'status' },
        key: 'status'
      }, {
        title: this.$t('user.bindTime'),
        dataIndex: 'create_time',
        align: 'center',
        width: 160,
        key: 'create_time'
      }, {
        title: this.$t('user.action'),
        dataIndex: 'action',
        scopedSlots: { customRender: 'action' },
        width: 310,
        fixed: 'right',
        align: 'center',
        key: 'action'
      }],
      queryParams: {
        name: ''
      },
      loadData: (paramter) => {
        return loadPermissionList(Object.assign(this.queryParams, paramter)).then(res => {
          return res.result
        })
      },
      selectedRowKeys: [],
      selectedRows: [],
      isCN: getI18nLanguage() === 'zh-CN'
    }
  },
  created () {
    this.checkExpireNum()
  },
  methods: {
    moment,
    reloadTable () {
      this.$refs.table.refresh(true)
      this.checkExpireNum()
    },
    refreshTable () {
      this.$refs.table.refresh()
      this.checkExpireNum()
    },
    checkExpireNum () {
      loadPermissionList({ pageNo: 1, pageSize: 100 }).then(res => {
        const ds = res.result.data
        let expireNum = 0
        for (const d of ds) {
          if (d.user_level === 0 || moment(d.level_expire).diff(moment(), 'days') <= 5) {
            expireNum++
          }
        }
        this.expireNum = expireNum
      })
    },
    handleMenuClick (e) {
      switch (e.key) {
        case '1':
          this.showModal(QrBind, this.$t('user.action.scanBind'), 360, 400)
          break
        case '2':
          this.showModal(EmailBind, this.$t('user.action.emailBind'), 500, 500)
          break
      }
    },
    confirmDel (id) {
      deleteSharePermission({ id: id }).then(res => {
        this.refreshTable()
      })
    },
    showUserProfile (uid, editable) {
      this.showModal(UserProfile, this.$t('user.profile'), 700, this.isCN ? 300 : 600, { uid: uid, editable })
    },
    search () {
      this.$refs.table.refresh()
    },
    upgrade (record) {
      this.showModal(MembershipUpgrade, this.$t('user.membership.upgrade'), 800, 520, { record: record })
    },
    switchMembership (record) {
      changeUserMembership({ userid: record.user_id, user_level: record.user_level === 2 ? 1 : 2 }).then(res => {
        this.refreshTable()
      })
    },
    handeChangeSwitch (e, record) {
      switchEmailAlertEnable({
        email_alert: e ? 1 : 0,
        id: record.id
      }).then(res => {
        this.refreshTable()
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      console.log('selectedRowKeys changed: ', selectedRowKeys)
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    deleteMultiple () {
       this.$confirm({
         title: this.$t('user.action.delete.title'),
         content: this.$t('user.action.delete.content'),
         okText: this.$t('user.action.ok'),
         cancelText: this.$t('user.action.cancel'),
         onOk: () => {
           deleteSharePermission({ id: this.selectedRowKeys }).then(res => {
             this.refreshTable()
           })
         }
       })
    },
    upgradeMultiple () {
       this.showModal(MembershipUpgradeBatch, this.$t('user.membership.upgrade'), 800, 520, { selectedRows: this.selectedRows })
    },
    showCreateAccount () {
      this.showModal(CreateAccount, this.$t('user.action.driverCreate'), 500, 400)
    },
    showResetPassword (record) {
      this.showModal(ResetPassword, this.$t('user.password.reset'), 500, 400, { record: record })
    }
  }
}
</script>

<template>
  <div class="driver-list-page">
    <div class="filter-card">
      <div class="filter-card__body">
        <a-row :gutter="16" type="flex" align="middle">
          <a-col :lg="col.lg" :xl="col.xl">
            <div class="filter-item">
              <label class="filter-item__label">{{ $t('user.name') }}</label>
              <a-input class="filter-item__input" v-model="queryParams.name" allowClear :placeholder="$t('user.name')" />
            </div>
          </a-col>
          <a-col :lg="col.lg" :xl="col.xl">
            <div class="filter-item filter-item--actions">
              <a-button @click="search">{{ $t('user.action.search') }}</a-button>
            </div>
          </a-col>
          <a-col :lg="col.lg" :xl="12">
            <div class="filter-actions-right">
              <a-button icon="plus" type="primary" @click="showCreateAccount">{{ $t('user.action.driverCreate') }}</a-button>
              <a-dropdown>
                <a-menu slot="overlay" @click="handleMenuClick">
                  <a-menu-item key="1">
                    <a-icon type="qrcode" />
                    {{ $t('user.action.scanBind') }}
                  </a-menu-item>
                </a-menu>
                <a-button icon="link">{{ $t('user.action.bind') }}</a-button>
              </a-dropdown>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>

    <div class="table-card">
      <a-alert
        v-if="expireNum > 0"
        class="table-card__alert"
        :message="$t('user.membership.expire.alert').replace('{num}', expireNum)"
        type="warning"
        show-icon
        closable />
      <div class="batch-bar">
        <a-button type="danger" :disabled="selectedRowKeys.length === 0" icon="delete" @click="deleteMultiple">{{ $t('user.bind.delete.multiple') }}</a-button>
        <a-button icon="arrow-up" :disabled="selectedRowKeys.length === 0" @click="upgradeMultiple">{{ $t('user.membership.upgrade.multiple') }}</a-button>
        <span v-if="selectedRowKeys.length > 0" class="batch-bar__count">{{ $t('user.action.selected') }} {{ selectedRowKeys.length }}</span>
      </div>
      <s-table
        :columns="columns"
        :data="loadData"
        :locale="locale"
        ref="table"
        :rowKey="record => record.id"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :scroll="{ x: 1700 }">
        <span slot="status" slot-scope="text, record">
          <span v-if="record.status === 1" class="status-badge status-badge--enable">
            <span class="status-badge__dot"></span>{{ $t('user.share.status.enable') }}
          </span>
          <span v-else class="status-badge status-badge--disable" :title="$t('user.share.status.disable.tip')">
            <span class="status-badge__dot"></span>{{ $t('user.share.status.disable') }}
          </span>
        </span>
        <span slot="expire" slot-scope="text, record" class="cell-muted">
          {{ record.user_level > 0 ? moment(record.level_expire).format('YYYY-MM-DD HH:mm:ss') : '-' }}
        </span>
        <span slot="email_alert" slot-scope="text, record">
          <a-switch :checked="record.email_alert === 1" @change="handeChangeSwitch($event, record)" />
        </span>
        <div slot="level" slot-scope="text, record">
          <div v-if="record.membership_switch_enable">
            <a-dropdown :trigger="['hover']">
              <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                <span v-if="record.user_level === 1" class="level-badge level-badge--pro">
                  <span class="level-badge__dot"></span>{{ $t('user.membership.level.pro') }}
                  <a-icon type="down" class="level-badge__arrow"></a-icon>
                </span>
                <span v-if="record.user_level === 2" class="level-badge level-badge--plus">
                  <span class="level-badge__dot"></span>{{ $t('user.membership.level.plus') }}
                  <a-icon type="down" class="level-badge__arrow"></a-icon>
                </span>
              </a>
              <a-menu slot="overlay">
                <a-menu-item key="0">
                  <a @click="switchMembership(record)" v-if="record.user_level === 1">{{ $t('user.membership.switchTo.plus') }}</a>
                  <a @click="switchMembership(record)" v-if="record.user_level === 2">{{ $t('user.membership.switchTo.pro') }}</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
          <div v-else>
            <span v-if="record.user_level === 0" class="level-badge level-badge--trial">
              <span class="level-badge__dot"></span>{{ $t('user.membership.level.trial') }}
            </span>
            <span v-if="record.user_level === 1" class="level-badge level-badge--pro">
              <span class="level-badge__dot"></span>{{ $t('user.membership.level.pro') }}
            </span>
            <span v-if="record.user_level === 2" class="level-badge level-badge--plus">
              <span class="level-badge__dot"></span>{{ $t('user.membership.level.plus') }}
            </span>
          </div>
        </div>
        <div slot="action" slot-scope="text, record" class="action-cell">
          <a-popconfirm
            @confirm="confirmDel(record.id)"
            :title="$t('user.action.delete.tip')"
            :ok-text="$t('user.action.delete.yes')"
            :cancel-text="$t('user.action.delete.no')">
            <a class="action-link action-link--danger">{{ $t('user.action.delete') }}</a>
          </a-popconfirm>
          <span class="action-divider"></span>
          <a class="action-link action-link--upgrade" @click="upgrade(record)">{{ $t('user.membership.upgrade') }}</a>
          <span class="action-divider"></span>
          <a-dropdown :trigger="['click']">
            <a class="action-link" @click="e => e.preventDefault()">
              {{ $t('user.action.more') }}
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="showUserProfile(record.user_id, record.creator !== null)">{{ $t('user.profile') }}</a>
              </a-menu-item>
              <a-menu-item v-if="record.creator">
                <a @click="showResetPassword(record)">{{ $t('user.password.reset') }}</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </s-table>
    </div>
  </div>
</template>

<style scoped lang="less">
@primary: #52C41A;
@border-color: #e8e8e8;
@text-primary: rgba(0, 0, 0, 0.85);
@text-secondary: rgba(0, 0, 0, 0.45);
@radius: 6px;
@shadow-card: 0 1px 2px rgba(0, 0, 0, 0.06), 0 1px 3px rgba(0, 0, 0, 0.04);
@transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);

.driver-list-page {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* ── Filter card ── */
.filter-card {
  background: #fff;
  border-radius: @radius;
  box-shadow: @shadow-card;
  overflow: hidden;

  &__body {
    padding: 12px 20px 16px;
  }
}

.filter-item {
  display: flex;
  align-items: center;

  &__label {
    flex-shrink: 0;
    width: 56px;
    font-size: 13px;
    color: @text-secondary;
    text-align: right;
    margin-right: 10px;
    white-space: nowrap;
  }

  &__input {
    flex: 1;
    min-width: 0;
  }

  &--actions {
    display: flex;
    align-items: center;
    gap: 8px;
  }
}

.filter-actions-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
}

/* ── Table card ── */
.table-card {
  background: #fff;
  border-radius: @radius;
  box-shadow: @shadow-card;
  padding: 16px 20px;

  &__alert {
    margin-bottom: 12px;
    border-radius: @radius;
    border: none;
  }
}

.batch-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;

  &__count {
    font-size: 13px;
    color: @text-secondary;
    margin-left: 4px;
  }
}

.cell-muted {
  color: @text-secondary;
  font-size: 13px;
}

/* ── Status badges ── */
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px 10px;
  border-radius: 100px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.6;
  white-space: nowrap;

  &__dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  &--enable {
    background: #f6ffed;
    color: #389e0d;

    .status-badge__dot {
      background: @primary;
    }
  }

  &--disable {
    background: #fff1f0;
    color: #cf1322;

    .status-badge__dot {
      background: #ff4d4f;
    }
  }
}

/* ── Level badges ── */
.level-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px 10px;
  border-radius: 100px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.6;
  white-space: nowrap;

  &__dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  &__arrow {
    font-size: 10px;
    margin-left: 2px;
  }

  &--trial {
    background: #f5f5f5;
    color: rgba(0, 0, 0, 0.65);

    .level-badge__dot {
      background: #bbb;
    }
  }

  &--pro {
    background: #fff7e6;
    color: #d48806;

    .level-badge__dot {
      background: #FF9900;
    }
  }

  &--plus {
    background: #fffbe6;
    color: #ad8b00;

    .level-badge__dot {
      background: #FFCC00;
    }
  }
}

/* ── Action cell ── */
.action-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  white-space: nowrap;
}

.action-link {
  font-size: 13px;
  color: @text-primary;
  transition: color @transition;
  padding: 0 2px;

  &:hover {
    color: @primary;
  }

  &--danger {
    color: #ff4d4f;

    &:hover {
      color: #ff7875;
    }
  }

  &--upgrade {
    color: #d48806;

    &:hover {
      color: #faad14;
    }
  }
}

.action-divider {
  display: inline-block;
  width: 1px;
  height: 14px;
  margin: 0 8px;
  background: @border-color;
  vertical-align: middle;
}

@media (max-width: 768px) {
  .filter-card__body {
    padding: 12px;
  }

  .table-card {
    padding: 12px;
  }

  .filter-actions-right {
    justify-content: flex-start;
    margin-top: 8px;
  }
}
</style>
